import React, {useEffect} from 'react';
import Breadcrumbs from "../../../../ui/Breadcrumbs";
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import { makeStyles } from "@material-ui/core/styles";
import DeleteConfirmationModal from "../../../../ui/DeleteConfirmationModal";
import Progress from "../../../../ui/Progress";
import TopBar from "./components/TopBar";
import Box from "../../../../ui/Box";
import QuizDrawer from "../../components/QuizDrawer";

import MainInfo from "./components/MainInfo";
import Instructions from "./components/Instructions";
import Statistic from "./components/Statistic";
import Constructor from "./components/Constructor";
import ProgramConnect from "./components/ProgramConnect";
import Thanx from "./components/Thanx";
import CreatePublic from "./components/CreatePublic";
import {getQuizMain} from "../../store/actions";
import Tabs from "../../../../ui/Tabs";
import {useMediaQuery} from "react-responsive";
import {deleteQuizLogo, updateQuizLogo, updateQuizMain} from "../../store/send";

const useStyles = makeStyles(() => ({
  root: {
    display: "flex",
    background: "#F6FBFF"
  },
  pageRoot: {
    display: "flex",
    flexDirection: "column",
    flexGrow: 1
  },
  topBar: {
    marginBottom: 10
  }
}));

const items = [
  {
    label: "Опросы",
    link: "/work/app/quiz"
  },
  {
    label: "Проведение опросов",
    link: "/work/app/quiz/manage"
  },
];

const tabitems = [
  {number: 0, caption: "Основные параметры"},
  {number: 1, caption: "Заполнение опроса"},
  {number: 2, caption: "Статистика"}
];

const initialState = {
  editableQuizInfo: null,
  isEdited: true
};

const QuizView = ({ match, history, getQuizMain, quizMain,
                  updateQuizMain, isUpdatingQuiz, updatedQuiz,
                    deleteQuizLogo, updateQuizLogo}) => {
  const { id } = match.params;
  const classes = useStyles();
  const [state, setStateObject] = React.useState(initialState);

  const [deleteModalOpen, setDeleteModalOpen] = React.useState(false);
  const [isEditable, setEditable] = React.useState(false);

  const setState = (field, value) => {
    setStateObject({
      ...state,
      [field]: value
    });
  };

  const returnBack = () => history.push("/work/app/quiz/manage");

  useEffect(() => {
    getQuizMain(id);
  }, [id]);

  useEffect(() => {
    if (quizMain) {
      setState("editableQuizInfo", quizMain);
    }
  }, [quizMain]);

  const updateQuizData = () => {
    setState("isEdited", true);
    updateQuizMain(id, state.editableQuizInfo);
  };

  const isXlarge = useMediaQuery({minWidth: 1920});
  const isLarge = useMediaQuery({minWidth: 1024});
  const isSmall = useMediaQuery({maxWidth: 774});

  return (
    <div>
      <DeleteConfirmationModal
        modalText="Удалить опрос?"
        open={deleteModalOpen}
        onConfirm={() => {
          returnBack();
        }}
        handleClose={() => setDeleteModalOpen(false)}
      />
      <Breadcrumbs items={items} />
      {quizMain ? (
        <div className={classes.root}>
          <div className={classes.pageRoot}>
            <div className={classes.topBar}>
              <TopBar
                onReload={() => getQuizMain(id)}
                returnBack={returnBack}
                isUpdating={isUpdatingQuiz}
                onUpdate={updateQuizData}
                openDeleteModal={() => setDeleteModalOpen(true)}
                editmode={isEditable}
                setEditMode={()=>setEditable(true)}
                setViewMode={()=>setEditable(false)}
              />
            </div>
            <Tabs orientation={isSmall ? "horizontal" : "vertical"} items={tabitems}>
              <Box noMargin>
                <MainInfo initialData={quizMain}
                          editmode={isEditable}
                          onFormChange={formState => {
                            setState("editableQuizInfo", {
                              main: formState
                            });
                          }}
                          deleteQuizLogo={() => deleteQuizLogo(id)}
                          updateQuizLogo={(file) => updateQuizLogo(id, file)}/>
              </Box>
              <Box noMargin>
                <Constructor quizId={id}/>
              </Box>
              <Box noMargin>
                <Statistic quizId={id}/>
              </Box>
            </Tabs>
          </div>
          {isLarge &&
          <QuizDrawer quizId={id} open hideLink />}
        </div>
      ) : (
        <Progress />
      )}
    </div>
  );
};

const mapStateToProps = state => ({
  quizMain: state.manageQuiz.quizMain,
  isUpdatingQuiz: state.manageQuiz.isUpdatingQuiz,
  updatedQuiz: state.manageQuiz.updatedQuiz,
  isUpdatingLogo: state.manageQuiz.isUpdatingLogo
});

const mapDispatchToProps = dispatch => ({
  getQuizMain: id => dispatch(getQuizMain(id)),
  updateQuizMain: (id, data) => dispatch(updateQuizMain(id, data)),
  updateQuizLogo: (id, data) => dispatch(updateQuizLogo(id, data)),
  deleteQuizLogo: (id) => dispatch(deleteQuizLogo(id))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(QuizView));
